import { Col, Row } from 'react-bootstrap';
import sucesionImg from 'assets/img/landing/sucesionjpg.jpg'; // Asegúrate de mover tus imágenes a tu carpeta de assets o usar rutas relativas
import accidenteImg from 'assets/img/landing/6365340.webp';

const Privacidad = () => {
  return (
    <section className="py-10 bg-body-tertiary" id="sucesiones">
      <div className="container-small px-lg-7 px-xxl-3">
        <div className="text-center mb-9">
          <h2 className="fs-3 fs-lg-2">Política de Privacidad de Estudio Parkes</h2>
        </div>


        <Row className="align-items-center g-5 mb-10">
            <h3 className="fw-bold mb-3">Última actualización: 27/05/2026</h3>
            <p className="text-body-secondary">En Estudio Parkes ("nosotros", "nuestro" o "el Estudio"), valoramos y respetamos su privacidad. Esta Política de Privacidad describe cómo recopilamos, utilizamos y protegemos la información personal que usted nos proporciona a través de nuestro sitio web (estudioparkes.com) y nuestras herramientas de contacto (como WhatsApp y correo electrónico).</p>
            <p className="text-body-secondary">1. Información que recopilamos: Podemos recopilar información de identificación personal, como su nombre, número de teléfono, dirección de correo electrónico y detalles de su caso o consulta, únicamente cuando usted nos la proporciona voluntariamente al contactarnos para solicitar asesoramiento legal.</p>
            <p className="text-body-secondary">2. Uso de la información:
La información recopilada se utiliza exclusivamente para:

Responder a sus consultas legales.

Evaluar la viabilidad de su caso (despidos, accidentes, sucesiones, etc.).

Comunicarnos con usted respecto a nuestros servicios.</p>
            <p className="text-body-secondary">3. Protección de datos y secreto profesional:
Como estudio jurídico, toda la información que nos proporcione está protegida no solo por la Ley de Protección de Datos Personales, sino también por el estricto secreto profesional abogado-cliente. No vendemos, alquilamos ni compartimos su información personal con terceros, salvo que sea estrictamente necesario para el desarrollo de su caso y con su previo consentimiento.</p>
            <p className="text-body-secondary">4. Sus derechos:
Usted tiene el derecho de solicitar el acceso, rectificación, actualización o eliminación de sus datos personales en cualquier momento, enviando un correo electrónico a jap@estudioparkes.com.</p>

            <a href="https://api.whatsapp.com/send/?phone=5491153069479&text&type=phone_number&app_absent=0" className="btn btn-outline-primary rounded-pill mt-3" target="_blank" rel="noreferrer">Contactanos</a>
        </Row>

      </div>
    </section>
  );
};

export default Privacidad;